module.exports = __webpack_public_path__ + "img/ueno-photograph.defdf760.png";